module.exports = __webpack_public_path__ + "ht.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ht.svg
// module id = 600
// module chunks = 0